enum TimeEntryBreakStatusType {
  INSIDE_ENTRY,
  OUTSIDE_ENTRY,
  END_TIME_OUTSIDE,
  START_TIME_OUTSIDE,
  CONTAINS_ENTRY,
}

export default TimeEntryBreakStatusType;
